module.exports = __webpack_public_path__ + "static/media/RoomService_Meal1_Summary_Page1_Down.3860e6a2.png";